/**
 * Demo Page (ADDI)
 * ================
 * Loads the enhanced Demo-website (GSAP narrative) from /demo-website/index.html.
 * That version is the canonical "better" experience with:
 * - Scroll-driven image sequence and section overlays
 * - "Better Data from Day One" section: mostly white text, colored header & icons, no glow
 * - Phone number (888) 296-5621 under "Try Addi Now"
 * - Link to addi.vaultailab.com for the working dashboard
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function Demo() {
  return (
    <div className="relative w-full h-screen min-h-screen overflow-hidden bg-[#004d33]">
      <Link
        to="/"
        className="fixed top-4 right-4 z-[9999] flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-lg text-white/90 hover:bg-white/20 hover:text-white transition-all text-sm"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Site
      </Link>
      <iframe
        src="/demo-website/index.html"
        title="DME Commitment Predictor Hub – Addi Demo"
        className="absolute inset-0 w-full h-full border-0"
      />
    </div>
  );
}

export default Demo;
